import getConfig from 'next/config';
import each from 'lodash/each';

const serverConfig = {
  analyticsKey: 'mxogjyaFuZsBa7Kf',
  androidUrl: 'https://play.google.com/apps/internaltest/4699526193628171128',
  apiUrl: 'https://gateway.staging.jobcase.com',
  // LUT-532: Places country codes allowed for ORG addresses (comma-separated,
  // lowercase ISO). US + territories by default; add countries per environment
  // (helm) to enable international organizations. Job locations are NOT gated by
  // this - they stay on the US default inside PlacesAutocomplete.
  orgAddressCountries: 'us,pr,vi,gu,mp',
  arrivalCookieKey: 'jc_arrival_staging',
  embedlyApiKey: 'cbac060626384058a70e5d30053039eb',
  environment: 'local',
  facebookAppId: '1466143907044501',
  fireGTMPixels: 'false', // SHOULD ONLY BE DONE IN PRODUCTION
  filestackApiKey: 'ApB9tpx3eRWiTRykH8Vjfz',
  // Local key only (tied to sburt@jobcase.com) staging and production key kept in helm values
  googleClientId: '10709691103-l7ni13u7fun4r01qhv01v4raseutdbkv.apps.googleusercontent.com',
  googleTagManagerId: 'GTM-K6G2FBQ',
  iosUrl: 'https://appstore.com/jobcase',
  jobcaseUrl: 'https://staging1.jobcase.com',
  logLevel: 'ERROR',
  mediaServiceUrl: 'https://media.staging.jobcase.com',
  // EC1 partner login. Staging default; production set via helm to
  // https://www.upward.net/t/auth/login/jobcase
  partnerReportingUrl: 'https://stage.upward.net/t/auth/login/jobcase',
  newRelicLicenseKey: '',
  rollbarClientToken: '',
  rollbarServerToken: '',
  ssoUrl: 'https://staging-sso.jobcase.com',
  getstreamApiKey: 'attkhbgcdb2y',
  stripeApiKey: 'pk_test_51L1G9VBhmn2nU6LTonONTYIDOkX6pCrTAUHh0KgU7Tm22NdA2v1cWtXWI0aU0WSCJ41j2rXH3Y5gQgoSGPZjy03e00UA3VHnti',
  tokensCookieKey: 'jc_tokens_staging',
  userAdminUrl: 'http://ua-staging-rails-app1.aws.p11a.com',
  vapidKey: 'BHe8Nw08G7XKML3Y-Kf3qZ-8nii7JG31vtC4Kmts_JlDZulb-LhLMMFFgBxAlS0BRw6cbiYXmemyDk8pDch8kb8=',
  ypaAdConfig: '000000958',
  ypaAffiliateId: '511885',
};

const clientConfig = {
  analyticsKey: 'mxogjyaFuZsBa7Kf',
  androidUrl: 'https://play.google.com/apps/internaltest/4699526193628171128',
  apiUrl: 'https://gateway.staging.jobcase.com',
  // LUT-532: see serverConfig.orgAddressCountries.
  orgAddressCountries: 'us,pr,vi,gu,mp',
  arrivalCookieKey: 'jc_arrival_staging',
  cloudinaryEnabled: false,
  embedlyApiKey: 'cbac060626384058a70e5d30053039eb',
  environment: 'local',
  facebookAppId: '10152575925196398',
  fireGTMPixels: 'false', // SHOULD ONLY BE DONE IN PRODUCTION
  filestackApiKey: 'ApB9tpx3eRWiTRykH8Vjfz',
  // TODO: Replace with staging account when available (current key is tied to sburt@jobcase.com)
  googleAnalyticsKey: 'UA-155725737-1',
  // Local key only (tied to sburt@jobcase.com) staging and production key kept in helm values
  googleClientId: '10709691103-l7ni13u7fun4r01qhv01v4raseutdbkv.apps.googleusercontent.com',
  googleTagManagerId: 'GTM-K6G2FBQ',
  fullStoryOrgId: '',
  linkedInClientId: '77zatilqjkl4lh',
  iosUrl: 'https://appstore.com/jobcase',
  jobcaseUrl: 'https://staging1.jobcase.com',
  logLevel: 'ERROR',
  mediaServiceUrl: 'https://media.staging.jobcase.com',
  // EC1 partner login. Staging default; production set via helm to
  // https://www.upward.net/t/auth/login/jobcase
  partnerReportingUrl: 'https://stage.upward.net/t/auth/login/jobcase',
  rollbarClientToken: '',
  ssoUrl: 'https://staging-sso.jobcase.com',
  getstreamApiKey: 'attkhbgcdb2y',
  stripeApiKey: 'pk_test_51L1G9VBhmn2nU6LTonONTYIDOkX6pCrTAUHh0KgU7Tm22NdA2v1cWtXWI0aU0WSCJ41j2rXH3Y5gQgoSGPZjy03e00UA3VHnti',
  tokensCookieKey: 'jc_tokens_staging',
  userAdminUrl: 'http://ua-staging-rails-app1.aws.p11a.com',
  vapidKey: 'BHe8Nw08G7XKML3Y-Kf3qZ-8nii7JG31vtC4Kmts_JlDZulb-LhLMMFFgBxAlS0BRw6cbiYXmemyDk8pDch8kb8=',
  ypaAdConfig: '000000958',
  ypaAffiliateId: '511885',
  googlePlacesAPIKey: 'AIzaSyDwEn-YFojC_elwdsH_qV-cToVElDeJXLw',
};

if (process.env.ENVIRONMENT !== 'test') {
  const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();

  // Overwrite config with proper environment variables if present.
  each(serverRuntimeConfig, (value, key) => { serverConfig[key] = value || serverConfig[key]; });
  each(publicRuntimeConfig, (value, key) => { clientConfig[key] = value || clientConfig[key]; });
}

export default process.browser ? clientConfig : serverConfig;
